import React from 'react';
import { camelCase } from 'lodash';
import { Control } from 'react-hook-form';
import { SurveyQuestion } from '../../../../../../../../entities/survey_engine/SurveyQuestion';
import { MultiAttachmentInputFormField } from '../../../../../../../../components/MultiAttachmentInputFormField';
import { SubmitApplicationFormDto } from '../../..';

interface PropTypes {
  control: Control<SubmitApplicationFormDto>;
  question: SurveyQuestion;
  disabled?: boolean;
}

export function MultiAttachmentQuestionInput(props: PropTypes) {
  return (
    <MultiAttachmentInputFormField<SubmitApplicationFormDto>
      controller={{
        mainController: camelCase(props.question.tag),
        content: 'content',
        fileName: 'filename',
        size: 'size',
      }}
      allowedFormats={['.pdf', '.doc', '.docx']}
      className='p-0'
      maxFileSizeMb={10}
      maxFilesSizeMb={20}
      maxTotalFiles={props.question.maxOptions ?? 6}
      isRequired={props.question.mandatory}
      disabled={props.disabled ?? false}
      control={props.control}
    />
  );
}
